module.exports = __webpack_public_path__ + "static/img/showpic3.fabe8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/showpic3.png
// module id = /UCc
// module chunks = 37